<template>
    <div>
        <input type="text" placeholder="Search..." class="form-control mb-3" v-model="search"
               v-on:keyup="getContacts()"/>
        <table class="table table-sm">
            <tbody>
            <tr v-for="contact in contacts.data" :key="`contact-data-${contact.id}`">
                <td width="25%">
                    <label class="custom-control material-checkbox" :for="'contact-check'+contact.id">
                        {{contact.name}}
                    </label>
                </td>
                <td width="25%">{{contact.email}}</td>
                <td width="25%">{{contact.phone_number}}</td>
                <td width="1%">
                    <label class="custom-control material-checkbox tw-cursor-pointer">
                        <input type="checkbox"
                               class="material-control-input"
                               @click="addContactToGroup(contact.id)"
                               :id="'contact-check'+contact.id"
                               :checked="contact.groups.length === 1">
                        <span class="material-control-indicator"></span>
                    </label>
                </td>
            </tr>
            </tbody>
        </table>
        <pagination :spacing="2" :meta="contacts" :links="contacts" @page="gotoPage"></pagination>
    </div>
</template>
<script>
    export default {
        props: {groupId: Number},

        data() {
            return {
                key      : null,
                locations: [],
                contacts : [],
                id       : null,
                search   : null,
            };
        },

        mounted() {
            this.init();
        },

        watch: {
            groupId() {
                this.init();
            }
        },

        methods: {
            async init() {
                this.id = this.groupId;
                await this.getLocations();
                this.getContacts();
            },

            addContactToGroup(contactId) {
                this.$http.post('/contact-group', {
                    contact_id: contactId,
                    group_id  : this.groupId,
                });
            },

            getLocations() {
                if (this.id) {
                    return this.$http.get('/group-locations/' + this.id).then((response) => {
                        this.locations = response.data;
                    });
                }
            },

            getContacts(page) {
                let params = {
                    page     : page,
                    search   : this.search,
                    locations: this.locations,
                };
                if (this.id) {
                    this.$http.get('/group-contacts/' + this.id, {params: params})
                        .then((response) => {
                            this.contacts      = response.data;
                            this.contacts.prev = this.contacts.prev_page_url ? this.contacts.prev_page_url : undefined;
                            this.contacts.next = this.contacts.next_page_url ? this.contacts.next_page_url : undefined;
                        });
                }
            },

            gotoPage(page) {
                this.getContacts(page);
            },

        }
    }

</script>
